import { createFileRoute } from '@tanstack/react-router';
import Support from '@src/app-pages/Support/Support';

export const Route = createFileRoute('/support/')({
  component: Support,
});
